(() => {
  document.querySelectorAll('[data-signalready]').forEach(section => {
    const quantity = section.querySelector('[name="quantity"]');
    const bundles = [...section.querySelectorAll('[data-sr-bundle]')];
    bundles.forEach(input => input.addEventListener('change', () => { quantity.value = input.value; }));
    quantity.addEventListener('input', () => bundles.forEach(input => { input.checked = Number(input.value) === Number(quantity.value); }));
    const selectMedia = input => {
      if (input.dataset.media) section.querySelector('[data-gallery]')?.dispatchEvent(new CustomEvent('show-variant-media', { detail: input.dataset.media }));
    };
    section.querySelectorAll('[data-sr-variant]').forEach(input => input.addEventListener('change', () => {
      selectMedia(input);
      const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState({}, '', url);
    }));
    const selected = section.querySelector('[data-sr-variant]:checked');
    if (selected) selectMedia(selected);
  });
})();
